var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.82,
    height: 12.302,
    viewBox: "0 0 15.82 12.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-home",
    "data-name": "Icon awesome-home",
    d: "M7.7,5.445,2.636,9.615v4.5a.439.439,0,0,0,.439.439l3.078-.008a.439.439,0,0,0,.437-.439V11.48a.439.439,0,0,1,.439-.439H8.787a.439.439,0,0,1,.439.439v2.627a.439.439,0,0,0,.439.441l3.076.009a.439.439,0,0,0,.439-.439v-4.5L8.119,5.445A.335.335,0,0,0,7.7,5.445Zm8,2.834L13.4,6.387v-3.8a.33.33,0,0,0-.33-.33H11.534a.33.33,0,0,0-.33.33V4.577L8.746,2.554a1.318,1.318,0,0,0-1.675,0L.119,8.279a.33.33,0,0,0-.044.464l.7.851a.33.33,0,0,0,.464.045L7.7,4.319a.335.335,0,0,1,.42,0L14.58,9.64a.33.33,0,0,0,.464-.044l.7-.851a.33.33,0,0,0-.047-.465Z",
    transform: "translate(0.001 -2.254)",
    fill: "#0b1741"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.4f514046e6944aaed9534711b61b2cdb.svg";
export { ForwardRef as ReactComponent };